import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSlackMessageMutationVariables = Types.Exact<{
  input: Types.CreateSlackMessageInput;
}>;

export type CreateSlackMessageMutation = {
  __typename?: 'Mutation';
  createSlackMessage: {
    __typename?: 'SlackMessage';
    id: any;
    text?: string | null;
    blocks?: any | null;
    threadTs?: string | null;
    createdAt: any;
    updatedAt: any;
    installation?: {
      __typename?: 'SlackInstallation';
      id: any;
      teamDomain?: string | null;
    } | null;
    channel?: {
      __typename?: 'SlackChannel';
      id: any;
      name?: string | null;
    } | null;
  };
};

export const CreateSlackMessageDocument = gql`
  mutation CreateSlackMessage($input: CreateSlackMessageInput!) {
    createSlackMessage(input: $input) {
      id
      text
      installation {
        id
        teamDomain
      }
      channel {
        id
        name
      }
      blocks
      threadTs
      createdAt
      updatedAt
    }
  }
`;
export type CreateSlackMessageMutationFn = Apollo.MutationFunction<
  CreateSlackMessageMutation,
  CreateSlackMessageMutationVariables
>;

/**
 * __useCreateSlackMessageMutation__
 *
 * To run a mutation, you first call `useCreateSlackMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackMessageMutation, { data, loading, error }] = useCreateSlackMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlackMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSlackMessageMutation,
    CreateSlackMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSlackMessageMutation,
    CreateSlackMessageMutationVariables
  >(CreateSlackMessageDocument, options);
}
export type CreateSlackMessageMutationHookResult = ReturnType<
  typeof useCreateSlackMessageMutation
>;
export type CreateSlackMessageMutationResult =
  Apollo.MutationResult<CreateSlackMessageMutation>;
export type CreateSlackMessageMutationOptions = Apollo.BaseMutationOptions<
  CreateSlackMessageMutation,
  CreateSlackMessageMutationVariables
>;
